import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import PromotionService from "../Services/OnePageServices";
import i18n, { _get_i18Lang } from "../i18n";
import { Breadcrumbs } from "./E-BooksComponent";
import { useNavigate } from "react-router-dom";
import Share from "../Images/ShareIcon.svg";
import GstLogo from "../Images/gitaseva.png";
import "../Styles/LyricsComponent.css"
import Loading from "../Components/Loading";
import Loader from "./Loader";

const PromotionPage = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const [promoData, setPromoData] = useState<any[] | undefined>(undefined);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [copied, setCopied] = useState(false);

    const contentRef = useRef<HTMLDivElement>(null);

    const handleCopy = () => {
        const text = contentRef.current?.innerText || '';

        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();

        try {
            const success = document.execCommand("copy");
            setCopied(true); // Mark as copied

            setTimeout(() => {
                setCopied(false);
            }, 800);

        } catch (err) {
            alert("कॉपी सपोर्टेड नहीं है ❌");
        }
        document.body.removeChild(textarea);
    };

    const htmlContent = `<div style="font-size: 19px; font-family: ChanakyaUni; text-align: left;">
    <p style="text-align: center;">॥ श्रीहरि: ॥</p>
    <h5> गीता सेवा ट्रस्ट द्वारा निर्मित <strong> Gita Seva</strong> ऐप एवं वेबसाइट <a href="https://gitaseva.org/app" target="_blank">(https://gitaseva.org/app)</a> में निम्नलिखित सामग्री नि:शुल्क उपलब्ध है -</h5>
    <p style="margin-bottom: 1px;">
    <strong>ई-पुस्तकें - </strong> गीता, रामायण, महाभारत, पुराण, उपनिषद, श्रद्धेय श्रीजयदयालजी गोयन्दका, श्रद्धेय श्रीहनुमानप्रसादजी पोद्दार तथा श्रद्धेय स्वामी श्रीरामसुखदासजी महाराज प्रणीत सत् साहित्य, स्त्रियोपयोगी, बालोपयोगी एवं सर्वोपयोगी पुस्तकों का विभिन्न भाषाओं में संग्रह।
    </p>
    <p style="margin-bottom: 1px;">
    <strong>पत्रिकाएँ -</strong> कल्याण (हिन्दी मासिक), कल्याण-कल्पतरु (अंग्रेजी मासिक) के कई पुराने दुर्लभ अंक, गीत-गोविन्द (हिन्दी तथा अंग्रेजी मासिक ई-पत्रिका) तथा विवेक वाणी (बंगला त्रैमासिक ई-पत्रिका)।
    </p>
    <p style="margin-bottom: 1px;">
    <strong>प्रवचन - </strong> श्रद्धेय श्रीजयदयालजी गोयन्दका, श्रद्धेय श्रीहनुमानप्रसादजी पोद्दार तथा श्रद्धेय स्वामी श्रीरामसुखदासजी महाराज के हजारों प्रवचनों का संग्रह।
    </p>
    <p style="margin-bottom: 1px;">
    <strong>ऑडियो - </strong> गीता पाठ, रामायण पाठ, हनुमानचालीसा, सुन्दरकाण्ड, आरती संग्रह, भागवत कथा, महाभारत कथा, भजन तथा कीर्तन इत्यादि।
    </p>
    <p style="margin-bottom: 1px;">
    <strong>वीडियो - </strong> श्रीमद्भागवत महापुराण सम्पूर्ण कथा, महाभारत कथा, अध्यात्म रामायण तथा देवी भागवत कथा इत्यादि।
    </p>
    <p style="margin-bottom: 1px;">
    <strong>अमृत वचन तथा लेख - </strong> महापुरुषों के अनमोल वचन तथा लेख।
    </p>
    <p></P>
    <p>
    मनुष्य जीवन का लक्ष्य परम शांति की प्राप्ति हेतु उपलब्ध साग्री का उपयोग करने के लिये निम्न लिंक से ऐप इंस्टॉल करें - 
    <a href="https://gitaseva.org/app" target="_blank"> https://gitaseva.org/app </a>
    कृपया इस धरोहर से स्वयं लाभ लें एवं सबके हित के लिये प्रचार-प्रसार में भी मदद करें। 🙏
    </p></div>`;

    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            try {
                const response = await PromotionService.getPromotionPageData(_get_i18Lang())
                const result = await response;
                if (result?.status) {
                    setPromoData(result?.result)
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false); // Hide loader after fetching
            }
        }
        fetchData();
    }, [i18n.language])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div style={{ marginBottom: "20px" }}>
            {promoData && promoData.length > 0 ? (
                <div>
                    <Breadcrumbs
                        mainsubBreadCrumb={t("promotion_tr")}
                        subBreadCrumb={t("Home_tr")}
                        navigatemainsubBreadCrumb={() => {
                            navigate(`/home`);
                        }}
                        subBreadCrumbTwo={t("promotion_tr")}
                        navigatesubBreadCrumb={() => {
                        }}
                    />
                    <div className="container">
                        {promoData?.map((data: any) => (
                            <div key={data?.id}>
                                {
                                    data?.promotionContent === null ?
                                        ""
                                        : <div>
                                            <div dangerouslySetInnerHTML={{ __html: data?.promotionContent }}
                                                style={{
                                                    background: "rgb(255, 246, 225)", boxShadow: "rgb(245, 222, 177) 0px 0px 7px 1px",
                                                    padding: "15px 20px 7%", marginTop: "20px", position: 'relative'
                                                }} />
                                            <div
                                                onClick={() => setIsModalOpen(true)}
                                                style={{
                                                    display: "flex",
                                                    position: "absolute",
                                                    marginTop: "-75px",
                                                    marginLeft: "28%",
                                                    borderRadius: "12px",
                                                    border: "2px solid #eb8635",
                                                    padding: "0 10px 2px 0",
                                                    background: "#fff1cc",
                                                    cursor: "pointer"
                                                }}>
                                                <img src={Share} alt="shareicon" style={{ height: "40px", width: "40px" }} />
                                                <h3 style={{ color: "#eb8635", paddingTop: "5px", fontFamily: 'ChanakyaUni', margin: 0 }}>{t("shareApp_tr")}</h3>
                                                <img src={GstLogo} alt="gita-seva-Logo" width="75px" style={{ height: "fit-content" }} />

                                                {isModalOpen && (
                                                    <div
                                                        className="modalOverlay"
                                                        onClick={(e) => {
                                                            e.stopPropagation(); // Prevent clicks on the overlay from affecting the modal content
                                                        }}>
                                                        <div className="modalContent">
                                                            <div
                                                                ref={contentRef}
                                                                dangerouslySetInnerHTML={{ __html: htmlContent }}
                                                            />
                                                            {copied && <p style={{ color: "green", fontSize: "18px", fontFamily: 'ChanakyaUni' }}>{t("Copyed_tr")}</p>}
                                                            <button
                                                                className="bottombuttons"
                                                                onClick={handleCopy}>
                                                                {t("copy_tr")}
                                                            </button>

                                                            <button
                                                                onClick={() => setIsModalOpen(false)}
                                                                className="bottombuttons"
                                                                style={{ marginLeft: "10px" }}>
                                                                {t("closemodel_tr")}
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                }
                            </div>
                        )
                        )}
                    </div>
                    <div className="container">
                        <div className="row">
                            {promoData?.map((showdata: any) => {
                                return (
                                    <div className="col-3" style={{ textAlign: "center" }} key={showdata?.id}>
                                        <a href={showdata?.pdfPath}
                                            target="_blank"
                                            title="pdf" rel="noopener noreferrer">
                                            <img src={showdata?.promotionThumbPath} alt="" style={{ width: "60%", marginTop: "30px", height: "75%" }} />
                                            <h6 style={{ fontFamily: 'ChanakyaUni', fontSize: "18px", margin: "10px 0 0 0", color: "#3f220d" }}>{showdata?.name}</h6>
                                        </a>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="ebooks-category resultnotfound">
                    {promoData?.length === 0 ? (
                        <label>{t("result_not_found_tr")}</label>
                    ) : (
                        loading && <Loader loading={loading} />
                    )}
                </div>
            )}
        </div >
    )
}
export default PromotionPage;